require('./hireCardViaTError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    KNOWN_ERROR_CODE,
    REJECTED,
    LOW_CREDIT_SCORE
} = require('constants/hireCardSubmitScenarios');
const { catalogue, analyticsId } = require('../analytics/hireCardViaTAnalytics');

class HireCardViaTError extends React.Component {

    handleGoToDocumentation() {
        this.props.history.push('/myprofile/documentation');
    }

    buildTexts() {
        const { immHireCardViaT, hasAvailableAccounts, maxAllowedNumberCards, hireRestrictionFlag } = this.props;
        let titleKey = 'hireCardViaT-errorTitleGeneric';
        let textElement = (
            <div className="hire-card-via-t-error__text">
                <FormattedText
                    value="hireCardViaT-errorTextGeneric"
                />
            </div>
        );

        if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
            titleKey = 'hireCardViaT-errorTitleNotAvailableAccounts';
            textElement = formatText('hireCards-errorTextNotAvailableAccounts');
        }
        else if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }
        switch (immHireCardViaT.get('hiringStatus')) {
            case KNOWN_ERROR_CODE:
                titleKey = 'hireCardViaT-errorTitleGeneric';
                textElement = (
                    <div>
                        <div className="hire-card-via-t-error__text hire-card-via-t-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCreditErrors-${immHireCardViaT.get('errorMsg')}`}
                            />
                        </div>
                        <div className="hire-card-via-t-error__text">
                            <FormattedText
                                value="hireCardViaT-errorTextCallUs"
                            />
                        </div>
                        <div className="hire-card-via-t-error__phone">
                            <i className="hire-card-via-t-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardViaT-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case REJECTED:
                titleKey = 'hireCardViaT-errorTitleRejected';
                textElement = (
                    <div>
                        <div className="hire-card-via-t-error__text">
                            <FormattedText
                                value="hireCardViaT-errorTextCallUs"
                            />
                        </div>
                        <div className="hire-card-via-t-error__phone">
                            <i className="hire-card-via-t-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardViaT-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case LOW_CREDIT_SCORE:
                titleKey = 'hireCardViaT-errorTitleLowCreditScoreUpdated';
                const documentationLink = (
                    <a onClick={() => this.handleGoToDocumentation()} >
                        <FormattedText value="hireCardOpenCredit-documentation" />
                    </a>
                    );
                textElement = (
                    <div>
                        <div className="hire-card-via-t-error__text hire-card-via-t-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCardViaT-hireCardViaT_lowCreditScoreMessage_updated_1`}
                            />
                            {documentationLink}
                            <FormattedText
                                value={`hireCardViaT-hireCardViaT_lowCreditScoreMessage_updated_2`}
                            />
                        </div>
                    </div>
                );
                break;
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { hasAvailableAccounts, maxAllowedNumberCards, processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        } : hasAvailableAccounts && !maxAllowedNumberCards ? {
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardViaT-errorBackButtonText"
                />
            ),
            url: '/myprofile/global'
        } :
        ({
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCards-backButtonLabel"
                />
            ),
            url: '/myprofile/cards'
        });
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.VIA_T_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-via-t-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardViaTError.propTypes = {
    history: PropTypes.object.isRequired,
    immHireCardViaT: PropTypes.object.isRequired,
    hasAvailableAccounts: PropTypes.bool,
    maxAllowedNumberCards: PropTypes.bool,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardViaTError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = withRouter(HireCardViaTError);
